import { Component } from '@theme/component';

export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();
    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;
      if (videoSource) source.setAttribute('src', videoSource);
    }

    // Assure que les attributs HTML sont bien présents
    videoElement.setAttribute('autoplay', '');
    videoElement.setAttribute('muted', '');
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('loop', '');

    videoElement.muted = true;
    videoElement.loop = true;

    // Charge la vidéo
    videoElement.load();

    // Attend que la vidéo soit prête avant de la lancer
    videoElement.addEventListener('canplay', () => {
      const playPromise = videoElement.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log('Vidéo lancée avec succès');
          })
          .catch(error => {
            console.warn('Autoplay bloqué:', error);
            // Essaie avec un délai
            setTimeout(() => {
              videoElement.play().catch(() => {});
            }, 500);
          });
      }
    });

    // Empêche la pause
    videoElement.addEventListener('pause', () => {
      if (this.isMobile()) {
        videoElement.play().catch(() => {});
      }
    });

    // Réactive au changement d'onglet
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden && videoElement.paused && this.isMobile()) {
        videoElement.play().catch(() => {});
      }
    });
  }

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}